import React, { useState } from "react";
import { compose } from "redux";
import { withTranslation } from "react-i18next";
import { connect, useSelector } from "react-redux";
import * as front from "../../auth/_redux/authRedux";
import { GridLoader } from "react-spinners";
import { useLocation } from "react-router-dom";
import { config as mainConfig } from "./../../../config/config";
import { v4 as uuidv4 } from "uuid";
import { get_sso_info } from "../../../common/layout/_redux/layoutCrud";


function MyIranSSO(props) {
  let myConfig = Object.assign(mainConfig);

  const [isRedirecting, setIsRedirecting] = useState(false);
  const isLegal = props.isLegal !== undefined;
  const location = useLocation();
  const state = useSelector((state) => state.nama);

  const handleClick = () => {
     localStorage.setItem("sso_filters", JSON.stringify(state));
     localStorage.setItem("sso_login", true);
    setIsRedirecting(true);
    get_sso_info(mainConfig.apiServer).then(res => {

      var clientId = res.clientId[1].field_value
      var redirectUri = res.redirectUri[1].field_value
      const ssoUrl =
      `https://usw.msrt.ir/oauth2/authorize?response_type=code&scope=openid%20profile&client_id=${clientId}&state=state1&redirect_uri=${redirectUri}&nonce=nonce`
      window.location.href = ssoUrl;
      
    })
  };


  return (
    <>
      <div className={"hp-auth-panel p-3"}>
        <button
          className="btn_login_page my-2 text-center d-flex"
          style={{ backgroundColor: "#286090" }}
          onClick={handleClick}
        >
          {!isRedirecting ? (
            <div> ورود از طریق پنجره واحد خدمات دانشگاهی </div>
          ) : (
            <div className={"d-flex"}>
              <GridLoader size={7} color={"white"} />
              <div className={"mt-1 me-2 text-center"}>در حال انتقال</div>
            </div>
          )}
        </button>
      </div>
    </>
  );
}

export default compose(
  withTranslation(),
  connect(null, front.actions)
)(MyIranSSO);
